import script from "./ImageUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageUploader.vue?vue&type=script&setup=true&lang=ts"

import "./ImageUploader.vue?vue&type=style&index=0&id=2db4af2a&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/livoapp/LivoFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2db4af2a"]])

export default __exports__